// extracted by mini-css-extract-plugin
export default {"Dynamic":"DynamicTable_Dynamic__CCdiJ","tableWrapper":"DynamicTable_tableWrapper__9T8OE","noDataBox":"DynamicTable_noDataBox__L8yb1"};